(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heyhome-catalog-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hh-catalog-menu')) {
customElements.define('hh-catalog-menu',class extends HTMLElement {
 connectedCallback(){
  this.controller?.abort(); this.controller=new AbortController();
  const signal=this.controller.signal, details=this.querySelector('details'), panel=this.querySelector('.hh-catalog-menu__panel');
  const position=()=>{if(this.classList.contains('hh-catalog-menu--mobile'))return;const r=this.querySelector('summary').getBoundingClientRect();panel.style.left=Math.max(16,Math.min(r.left,innerWidth-panel.offsetWidth-16))+'px';panel.style.top=r.bottom+'px';};
  details.addEventListener('toggle',()=>{if(details.open)position();},{signal});
  window.addEventListener('resize',position,{signal});
  document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))details.open=false;},{signal});
  this.addEventListener('keydown',e=>{if(e.key==='Escape'){details.open=false;this.querySelector('summary').focus();}},{signal});
  this.addEventListener('click',e=>{if(e.target.closest('a')){details.open=false;const drawer=this.closest('header-drawer');if(drawer)drawer.querySelector('.menu-drawer__close-button')?.click();}},{signal});
 }
 disconnectedCallback(){this.controller?.abort();}
});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heyhome-hero-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hh-hero-carousel')) {
  customElements.define('hh-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.index = 0;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-index]'));
      this.querySelector('.hh-banner-controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-index')) this.show(Number(button.dataset.index));
        else if (button.hasAttribute('data-direction')) this.show(this.index + Number(button.dataset.direction));
      }, { signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.hh-banner-controls')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal: this.controller.signal });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.querySelector('[data-carousel-status]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heyhome-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heyhome-gallery')) {
  customElements.define('heyhome-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.hhReady) return;
      this.hhReady = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        const key = button.dataset.hhSwitch;
        if (key) {
          this.querySelectorAll('[data-hh-panel]').forEach(panel => { panel.hidden = panel.dataset.hhPanel !== key; });
          this.querySelectorAll('[data-hh-switch]').forEach(control => control.setAttribute('aria-pressed', String(control.dataset.hhSwitch === key)));
        }
        const zoom = button.dataset.hhZoom;
        if (zoom) {
          const dialog = this.querySelector('dialog');
          if (!dialog || typeof dialog.showModal !== 'function') return;
          this.querySelectorAll('[data-hh-zoom-panel]').forEach(panel => { panel.hidden = panel.dataset.hhZoomPanel !== zoom; });
          if (!dialog.open) dialog.showModal();
        }
        if (button.hasAttribute('data-hh-close')) this.querySelector('dialog')?.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
